/* eslint-disable */
import "./css/estampForm.css";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import mainurl from "../config/mainurl.mjs";
import secureLocalStorage from "react-secure-storage";

function Estampform() {
  const Navigate = useNavigate();
  const cc = secureLocalStorage.getItem("CC");
  const uid = secureLocalStorage.getItem("uid");
  // console.log(cc,uid);
  secureLocalStorage.removeItem("payid");

  const [Hide, setHide] = useState(true);
  const [show, setshow] = useState("");


  async function formapi() {
    setHide(false);
    await fetch(`${mainurl}/ddpiform`, {
      method: "POST",
      headers: { "Content-Type": "application/json","Authorization":"Basic RERQSS1BRlNMLUxJVkUtVjE6YXdlciQlY3MzNDVkXnp4dHkyNkAjZmdocVNEKmFa"},
      body: JSON.stringify({
        cc: cc,
        uid: uid,
      }),
    })
      .then((resp) => resp.json())
      .then((result) => {
        if(result.message=="Stamping could not be performed"){
          secureLocalStorage.clear();
          Navigate('/error')
        }
        setshow(result.content);
        // console.log(show);
      })
      .catch((error) => {
        // console.log(error);
        // alert('Something Went Wrong Please Try After Some Time')
      });
  }

  const [Agree, setAgree] = useState(true);
  function clientagree(e) {
    if (e.target.checked) {
      setAgree(true);
    } else {
      setAgree(false);
    }
  }
  const redirect = () => {
    secureLocalStorage.setItem('status',`${uid}esfc`)
    Navigate("/esign");
  };

// PREVENT TO REFRESH,BACK,AND ROUTES
// ================================================

  window.onpopstate = (e) => {
    const confirmation = confirm("Are you Sure you Want to Cancel ?");
    if (confirmation === true) {
      secureLocalStorage.clear();
      Navigate("/");
    } else {
      Navigate("/estampform");
    }
  };
// ==================================================================

  useEffect(() => {
    if(secureLocalStorage.getItem("status")!==`${uid}pStatus`){
      secureLocalStorage.clear();
      Navigate('/');
    }
    formapi();
  }, []);

  return (
    <>
      <button className="link-text absolute flex items-center text-sm bottom-4 left-2 md:left-10">
        <Icon icon="mdi:arrow-left" color="gray" />
        <Link to="https://almondztrade.com/" onClick={()=>secureLocalStorage.clear()}>Back to home</Link>
      </button>
      <div className="estampform-container">
        <div className="form-box flex justify-center items-center w-3/4 h-3/4 m-auto">
          {show == "" ? (
            <Icon
              icon="svg-spinners:6-dots-scale"
              color="orange"
              width="50"
              height="50"
            />
          ) : (
            <embed
              src={`data:application/pdf;base64,${show}#toolbar=0&scrollbar=0`}
              width="100%"
              height="100%"
              className={Hide === true ? "hide" : ""}
            />
          )}
        </div>
        <div className="checkinput-box flex justify-center items-center gap-2 mt-5 mb-5 mx-2 sm:mx-0">
          <input
            type="checkbox"
            checked={Agree==""?false:true}
            disabled={show==""?true:false}
            className=" check-box h-4 w-4"
            onChange={(e) => clientagree(e)}
          ></input>
          <p className="text-xs">
            I've reveiwed the DDPI document and I accept to proceed for digital
            e-sign.
          </p>
        </div>
        <div className="button-box">
          {/* <button className="active-btn"> view</button> */}
          <button
            className={show == "" ? "default-btn" : Agree == false ? "default-btn":"active-btn"}
            onClick={
              show == ""
                ? () => alert("Please Select the Checkbox")
                : Agree == true
                ? () => redirect()
                : () => alert("Please Select the Checkbox")
            }
          >
            E-Sign
          </button>
        </div>
      </div>
    </>
  );
}
export default Estampform;
